export default "__VITE_ASSET__CCW6EN_i__"